import { useParams } from "react-router-dom";
import OrderDetails from "../components/OrderDetails";
import PageLayout from "../layout/PageLayout";
import React from "react";

export default function Order(){

  const { orderCode: orderCodeParam } = useParams();

  if(!orderCodeParam)
    return <></>;

  const orderCode = parseInt(orderCodeParam);

  return <PageLayout pageTitle={`Ordine #${orderCodeParam}`}>
    <OrderDetails orderCode={orderCode} adminControls={true} />
  </PageLayout>
}